import { IPurchaseOrder } from 'interfaces/purchaseOrder';
import React, { useState } from 'react';
import { getEmptyItem } from '../create';
import OrderItems from '../create/orderItems';
import addItemStyles from './index.module.scss';
import styles from '../create/index.module.scss';
import ActionButton from 'components/ActionButton';
import { addInventoryItemsToPurchaseOrder } from 'services';
import { showError, showSuccess } from 'utils';

const AddInventoryItems = (props) => {
  const  { selectedSupplierId, onItemsAdd, poId } = props;
  const [items, setItems] = useState<IPurchaseOrder.IOrderItemType[]>
  ([getEmptyItem()]);
  const [loading, setLoading] = useState(false);

  const onClickAdd = async() => {
    try {
      setLoading(true);
      await addInventoryItemsToPurchaseOrder({
        id: poId, inventoryItems: items,
      });
      await onItemsAdd();
      setItems([getEmptyItem()]);
      showSuccess('Items added successfully');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return(
    <div className={addItemStyles['add-item-section']}>
      <div className={addItemStyles['section-header']}>
        <div className={addItemStyles['subheading']}>Add inventory items to PO</div>
      </div>
      <div className={styles['po-details-container']}>
        <OrderItems
          disabled={loading}
          items={items}
          setItems={setItems}
          selectedSupplier={selectedSupplierId}
          showAddInventoryItemButton
        />
      </div>
      <ActionButton
        text={'Add items to PO'}
        active={!loading}
        isLoading={loading}
        onClick={onClickAdd}
        customClass={addItemStyles['add-button']}
      />
    </div>
  );
};

export default AddInventoryItems;

{/*  */}